<template>
  <div class="dg__listItem" :class="{ inline: _inline }" :style="itemStyle">
    <div class="lable" :style="labelStyle" :class="[labelClass, list.labelClass]">
      <div class="lable" :style="labelStyle" :class="[labelClass, list.labelClass]"> <span v-if="required"
        class="t-[#FF4D4F]">*</span> 
        <slot name="label">
          {{ label || "" }}{{ label ? list.labelSuffix : "" }}
        </slot>
      </div>
    </div>
    <div class="value">
      <div class="value-width" :style="valueStyle">
        <slot></slot>
      </div>
      <div style="padding-top: 1px;">
        <slot name="else">

        </slot>
      </div>


    </div>
  </div>
</template>

<script>
// import { defineComponent, computed, inject } from "vue";
// import type { CSSProperties } from "vue";

export default {
  name: "dg-form-item",
  props: {
    valueStyle: {
      type: Object,
      default: () => {
        return { width: '60%' }
      }
    },
    required: {
      type: Boolean,
      default: false
    },
    copyContent: {
      type: String,
      default: "",
    },
    labelWidth: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      default: ""
    },

    inlineWidth: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: "200"
    },

    margin: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    list() {
      return this.$parent;
    },
    _inline() {
      return this.$parent.inline;
    },
    labelStyle() {
      let p = this.list;
      let   ret = {};
      let   labelWidth = this.labelWidth || p.labelWidth;
      let   color = this.color || p.color;
      let   size = this.size || p.size;
      if (labelWidth) {
        ret.flexBasis = labelWidth + "px";
      }
      if (color) {
        ret.color = color;
      }
      if (size) {
        ret.fontSize = size;
      }
      return ret;
    },
    itemStyle() {
      let p = this.list;
      let   ret = {};
      let   inlineWidth = this.inlineWidth || this.$parent.inlineWidth || p.inlineWidth;
      let   margin = p.margin;
      if (margin && margin.length) {
        ret.margin = margin
          .map(el => {
            return `${el}px`;
          })
          .join(" ");
      }

      if (p.inline && inlineWidth) {
        if (inlineWidth.indexOf('%') != -1) {
          ret.width = inlineWidth;
        } else {
          ret.width = inlineWidth + 'px'
        }
      }
      return ret;
    }
  },
  methods: {
    // 复制
    copyItem(content) {
      let txt = content
      if (navigator.clipboard && window.isSecureContext) {
        this.$message.success("复制成功")
        return navigator.clipboard.writeText(txt)
      } else {
        let   textArea = document.createElement("textarea")
        textArea.value = txt
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        this.$message.success("复制成功")
        return new Promise((res, rej) => {
          document.execCommand("copy") ? res() : rej()
          textArea.remove()
        })
      }
    },
    // // 复制信息
    // copyItem(content) {
    //   let ipt = document.getElementById("copyTxt");
    //   ipt.value = content;
    //   ipt.select();
    //   document.execCommand("copy");
    //   this.$message({
    //     type: "success",
    //     message: "复制成功"
    //   });
    // },
  }

};
</script>

<style scoped lang="less">
.dg__listItem {
  display: flex;
  flex-grow: 1;
}

.dg__listItem.inline {
  display: inline-flex;
  min-width: 200px;
  // margin-left: -5px;
}

.dg__listItem .value {
  flex: 1;
  overflow: hidden;
  text-align: left;
  padding-left: 4px;
  font-size: 14px;
  word-wrap: break-word;
  word-break: normal;
  color: #303133;
}

.dg__listItem .lable {
  position: relative;
  flex-basis: 80px;
  // padding-left: 5px;
  line-height: 32px;
  font-size: 14px;
  color: #909399;
}

.value {
  width: 100%;
  display: flex;
}

.value-width {
  /deep/ .el-form-item {
    width: 100%;

    .el-form-item__content {
      width: 100%;
    }
  }

  /deep/ .el-dropdown {
    width: 100% !important;
  }

  /deep/ .el-select {
    width: 100% !important;
  }

  /deep/ .el-form-item__error {
    width: 300px;
  }

  /deep/ .el-date-editor .el-range-separator {
    width: unset !important;
  }
}</style>
